export interface HomeScreenActions {
  /** Ответ в окне о ярлыке (`app/asks.ts`). */
  answerHomeScreen(add: boolean): void;
}

const noop = () => {};

export const defaults: HomeScreenActions = {
  answerHomeScreen: noop,
};

declare module "../actions" {
  interface WindowActions extends HomeScreenActions {}
}
